import { Titled } from 'react-titled';
import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

const CabinetPage: FC = () => (
  <>
    <Titled title={(title) => `WellTech User Acquisition | ${title}`} />
    <Outlet />
  </>
);

export default CabinetPage;
